"use client";
import React from "react";
import Header from "components/common/Header";
import Footer from "components/common/Footer";
import SectionDownloadApp from "components/common/SectionDownloadApp";
import FormProvider from "providers/FormProvider";
import useFilterForm from "hooks/useFilterForm";
import usePromise from "hooks/usePromise";
import usePagination from "hooks/usePagination";
import ShopService from "services/shop";
import WardService from "services/ward";
import { Filter } from "components/search";
import { assign, find, get } from "utils/lodash";

import { SectionVertical } from "components/home";
import { useRouteContext, useSearchParams } from "providers/RouteProvider";
import { usePageContext } from "providers/PageProvider";

import helper from "utils/helper";
const buildQuery = (values: any) => {
  const sort = get(values, "sort") || "";
  const input: any = helper.normalizeParams({
    where: {
      ...(get(values, "searchTerm")
        ? { name: { like: get(values, "searchTerm") } }
        : {}),
      ...(!!get(values, "ward") && {
        ward: { equals: get(values, "ward") },
      }),
      ...(!!get(values, "province") && {
        province: { equals: get(values, "province") },
      }),
      ...(!!get(values, "category", "") && {
        mainShopCategory: {
          equals: get(values, "category", ""),
        },
      }),
      // ...(get(values, "subShopCategories", []).length > 0 && {
      //   subShopCategories: {
      //     in: get(values, "subShopCategories", []),
      //   },
      // }),
    },
    page: get(values, "page"),
    limit: get(values, "limit"),
    sort,
  });
  console.log({ input });
  return input;
};

const Comp = () => {
  const { pageService } = usePageContext();

  const { router } = useRouteContext();
  const searchParams = useSearchParams();
  const searchTerm = searchParams.get("searchTerm") || "";
  const category = searchParams.get("category") || "";
  const province = searchParams.get("province") || "686a7e84fc7940dcf9bb772a";

  const ward = searchParams.get("ward") || "";
  const ref: any = React.useRef({ loading: true, first: true });
  const pagination = usePagination({
    initialParams: {
      page: 1,
      limit: 16,
    },
    loader: async (payload) => {
      const categories = get(pageService, "categories");
      const categoryId = get(
        find(categories, (item) => item.code === payload.category),
        "id"
      );
      const query = buildQuery(
        assign({}, ref.current.form.values, payload, {
          category: categoryId,
        })
      );
      const res = await ShopService.find(query);
      return {
        data: get(res, "data", []),
        total: get(res, "params.total", 0),
      };
    },
  });
  const form: any = useFilterForm({
    enableReinitialize: true,
    initialValues: {
      searchTerm,
      province,
      ward,
      category: category,
    },
    onSubmit: async (values: any) => {
      ref.current.pagination.submit(values);
    },
  });
  const [wards] = usePromise(
    async () => {
      if (!!form.values.province) {
        const res = await WardService.find({
          where: {
            province: {
              equals: "686a7e84fc7940dcf9bb772a",
            },
          },
          page: 1,
          limit: 200,
        });
        return get(res, "data", []);
        return [];
      }
      return [];
    },
    null,
    [form.values.province]
  );
  assign(ref.current, { form, pagination });
  assign(form, {
    selectOptions: {
      categories: get(pageService, "categories", []),
      subShopCategories: get(pageService, "subCategories", []),
      provinces: get(pageService, "provinces", []),
      wards: wards || [],
    },
  });
  const handler = {
    onChangeSearch: (searchTerm: string) => {
      ref.current.form.setFieldValue("searchTerm", searchTerm);
      ref.current.pagination.onSearch("searchTerm", searchTerm);
    },
    onShopClick: (item: any) => {
      router.push(`/${item?.slug}`);
    },
    onChangeFilter: (values: any) => {
      ref.current.form.setValues({ ...form.values, ...values });
      ref.current.pagination.submit({ ...form.values, ...values });
    },
  };
  React.useEffect(() => {
    ref.current.first = false;
    form.handleSubmit();
  }, []);
  return (
    <main className="relative flex flex-col h-screen">
      <FormProvider form={form}>
        <Header type="search" />
        <Filter
          onChangeSearch={handler.onChangeSearch}
          onChangeFilter={handler.onChangeFilter}
          parentForm={form}
        />
        <div className="flex-1 g-white">
          <SectionVertical
            title={"Cửa hàng"}
            description={"Khám phá các cửa hàng trên nền tảng Lookme"}
            pagination={pagination}
            onShopClick={handler.onShopClick}
          />
          <SectionDownloadApp />
        </div>
        <Footer />
      </FormProvider>
    </main>
  );
};

export default Comp;
